import dayjs from "dayjs";
import React from "react";
import Config from "../../util/config";

interface DayProps {
  className?: string;
  classNameDay?: string;
  clickable: boolean;
  onClick?: (day: dayjs.Dayjs) => void;
  month: dayjs.Dayjs;
  day: dayjs.Dayjs;
}

const Day = (props: DayProps) => {
  const { day, className, classNameDay, month } = props;
  const onClick = props.clickable ? props.onClick : () => {};

  const dayText = day.format(Config.get("dayFormat", "D"));

  const hideDaysNotInMonth = Config.get("hideDatesNotInMonth", 'no') === 'yes';
  const isDayInMonth = day.month() === month.month();
  if (hideDaysNotInMonth && !isDayInMonth) {
    return (
      <span style={{ pointerEvents: "none" }} className={`${className || ""} blank-date`} />
    );
  }


  return (
    <span onClick={() => onClick(day)} className={className || ""}>
      <span className={classNameDay || ""}>{dayText}</span>
    </span>
  );
};

export default Day;
